import src from "IMAGE";
export default { src, width: 1441, height: 1441, blurWidth: 0, blurHeight: 0};
